import { Link } from "react-router-dom";
import Event from "../UI/Event";
import React, { useEffect, useState } from "react"; 
import axios from "axios";
import { APIURL } from "../..";
import HashLink from "../UI/HashLink";
import Loading from "../UI/Loading";
import VDZlogo from '../../assets/loga/VDZ-white.svg'

const Events = () => { 
    const [eventsData, setEventsData] = useState({});
    const [loading, setLoading] = useState(true); 

    const getCurrentDate = () => { 
        var now = new Date();
        var currentMonth = now.getMonth()+1;
        if (currentMonth < 10) { currentMonth = '0' + currentMonth; };
        return now.getFullYear()+"-"+currentMonth+"-"+now.getDate()
    }

    const getEvents = async () => {
        await axios
            .post(APIURL + "/events", {
                type: 'events',
                orderAsc: "ASC",
                limit: 3,
                page: 1,
                language: 'cs',
                filter: [{name:"date", action:">", value:getCurrentDate()}]
            })
            .then((response) => { 
                setEventsData(response.data.body);
                setLoading(false)
            });
    };

    useEffect(() => {
        getEvents();
    }, []);
    return (
        <>
            <section className="events" id="events">
                <div className="events__box">
                    <div className="perex" style={{ paddingBottom: "0" }}>
                        <span>Události</span>
                        <h2>Kde nás najdete</h2>
                        <p>
                        Navštivte náš stánek na níže uvedených akcích a zažijte dopravní nehodu nanečisto. 
                        Pokud ale nemůžeš na akci, nezoufej! <HashLink href="#sluzby" style={{fontWeight:"bold", color:"white", textDecoration:"underline"}}>Stáhni si je</HashLink> do svých 
                        VR brýlí nebo si <HashLink href="#elearning" style={{fontWeight:"bold", color:"white", textDecoration:"underline"}}>zahraj e-learning</HashLink>
                        </p>
                    </div>

                    {loading ? (
                        <div style={{ margin: "2rem auto" }}>
                            <Loading />
                        </div>
                    ) : eventsData?.events?.length ? (
                        <>
                            <div className="events__container">
                                {eventsData.events.map((event, i) => (
                                    <Event key={i} event={event} />
                                ))}
                            </div>

                            <Link
                                to="/terminy"
                                className="button transBlue"
                                style={{ margin: "auto" }}
                            >
                                další události
                            </Link>
                        </>
                    ) : (
                        <div style={{ margin: "4rem auto", color:"white"}}>
                            Události zatím nebyly naplánovány.
                        </div>
                    )}
                    <div className="perex" style={{ flexDirection: "row"}}> 
                        <img src={VDZlogo} alt="ilustrace kalendáře" style={{ width: "200px", color:"white" }}/>
                        <p style={{ margin: "auto", color:"white" }}>
                            Nehodu nanečisto najdete na všech akcích, kam jezdíme s našimi partnery a tvoříme dohromady <a
                    href="http://virtualnidopravnizona.cz/" style={{ margin: "auto", color:"white", textDecoration:"underline" }}><b>Virtuální dopravní zónu.</b></a><br/>
                        </p>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Events;
